import React, { ReactNode, useMemo } from "react";
import Text from "@/components/marketing/Text";
import Section from "@/components/marketing/Section";

interface CustomerQuoteProps {
    children: ReactNode;
    image?: string;
    name?: string;
    position?: string;
};

const CustomerQuote: React.FC<CustomerQuoteProps> = ({
    children,
    image = '',
    name = '',
    position = '',
}) => {
    const randomGradient = useMemo(() => {
        const colors = [
            'from-gray-50', 'from-slate-50', 'from-zinc-50', 'from-neutral-50', 'from-stone-50',
            'from-warm-gray-50', 'from-true-gray-50', 'from-cool-gray-50'
        ];
        const toColors = [
            'to-gray-100', 'to-slate-100', 'to-zinc-100', 'to-neutral-100', 'to-stone-100',
            'to-warm-gray-100', 'to-true-gray-100', 'to-cool-gray-100'
        ];

        const randomFrom = colors[Math.floor(Math.random() * colors.length)];
        const randomTo = toColors[Math.floor(Math.random() * toColors.length)];

        return `bg-gradient-to-br ${randomFrom} ${randomTo}`;
    }, []);

    return (
      <Section contentWidth="content-xs" padding="p-none" className={`mx-auto my-6 bg-gradient-to-br from-slate-100 to-zinc-50 rounded-lg overflow-hidden relative`}>
          <div className="absolute inset-0 bg-gradient-to-br from-white/0 to-white/30 animate-gradient-shift"></div>
          <Section contentWidth="content-xxs" className="flex flex-col items-center gap-6 p-8 relative z-10">
              <div className="w-16 h-16 overflow-hidden rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out hover:scale-105">
                  <img
                    src={image}
                    alt={`Portrait of ${name}`}
                    className="w-full h-full object-cover"
                  />
              </div>
              <Text as="blockquote" size="xl" align="center" tracking="tight" color="primary">{children}</Text>
              <Text align="center">
                  <Text as="span" weight="semibold" color="primary" className="inline before:inline after:inline">{name}</Text>, {position}
              </Text>
          </Section>
      </Section>
    );
};

export default CustomerQuote;